const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function createFocusTrap(container, { signal } = {}) {
  let edges = queryEdges();

  const observer = new MutationObserver(() => (edges = queryEdges()));
  observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'tabindex', 'hidden'] });
  signal?.addEventListener('abort', () => observer.disconnect());

  function queryEdges() {
    const els = [...container.querySelectorAll(FOCUSABLE)].filter(
      (el) => !el.closest('[hidden], [aria-hidden="true"]')
    );
    return { first: els[0], last: els.at(-1) };
  }

  function handleKeydown(e) {
    if (e.key !== 'Tab') return;
    if (!edges.first) return;

    if (e.shiftKey && document.activeElement === edges.first) {
      e.preventDefault();
      edges.last?.focus();
    } else if (!e.shiftKey && document.activeElement === edges.last) {
      e.preventDefault();
      edges.first?.focus();
    }
  }

  container.addEventListener('keydown', handleKeydown, { signal });
  edges.first?.focus();
}
